<dx-popup class="field-crops-popup"
          width="75%"
          height="50%"
          [showTitle]="true"
          [(visible)]="visible"
          [elementAttr]="{class: 'field-crops-popup'}"
          [title]="title"
          [dragEnabled]="true"
          [resizeEnabled]="true"
          [shading]="false"
          [showCloseButton]="true"
          [closeOnOutsideClick]="false"
          (onShown)="onShown()">
  <div *dxTemplate="let model of 'content'">
    <app-field-crops-grid (closePopUp)="visible = false"></app-field-crops-grid>
  </div>
</dx-popup>
